<div class="device-flow">
  <div class="grid margin-bottom-xsmall">
    <!-- TODO: We only need this on certain steps add step check -->
    <div class="cell margin-right-medium margin-left-xmedium progress-nav">
      <button mat-icon-button color="primary">
        <mat-icon>west</mat-icon>
      </button>
    </div>
  </div>
  <div class="grid padding-bottom-xxbig device-flow-content">
    <div class="cell cell-large-col-span-12">
      <!-- <ng-container>
        <h1 class="margin-bottom-medium">Condition Check</h1>
        <p>Your excess will be £150 for any claim until you successfully validate your phone using our Condition Check.</p>
        <p class="margin-bottom-large">Follow the user-friendly steps, and we'll handle the rest. If your validation is successful, you will receive an email at (policy holder email) confirming the reduction of your excess.</p>
        <div class="open-form-info padding-medium margin-bottom-large">
          <strong>Important:</strong> Make sure you are using the device you wish to validate.
        </div>
        <h2>Your mobile</h2>
        <div class="margin-bottom-large">DEVICE SELECTION</div>
        <div class="device-flow-controls">
          <button mat-flat-button color="primary" class="device-flow-action">Start</button>
        </div>
      </ng-container> -->

      <!-- <ng-container>
        <h1 class="margin-bottom-medium">How to validate?</h1>
        <h2 class="margin-bottom-medium">1 - Take a “Phone selfie”</h2>
        <div class="grid grid-elastic margin-bottom-medium">
          <div class="cell">
            <img src="https://placehold.co/100x94" width="100" height="94">
          </div>
          <div class="cell">
            <p>Take a 'phone selfie' by holding the phone up to a mirror and taking a photo of the screen's reflection.</p>
            <p>Make sure to use the front camera (the 'selfie' camera)</p>
          </div>
        </div>
        <div class="open-form-info padding-medium margin-bottom-xlarge">
          <strong>Important:</strong> Keep the screen completely clear of fingers or any obstructions.
        </div>
        <h2 class="margin-bottom-medium">2 - Provide IMEI number</h2>
        <div class="grid grid-elastic margin-bottom-large">
          <div class="cell">
            <img src="https://placehold.co/100x94" width="100" height="94">
          </div>
          <div class="cell">
            <p>Take a 'phone selfie' by holding the phone up to a mirror and taking a photo of the screen's reflection.Make sure to use the front camera (the 'selfie' camera).</p>
          </div>
        </div>
        <div class="device-flow-controls">
          <button mat-flat-button color="primary" class="device-flow-action">Let’s get started</button>
        </div>
      </ng-container> -->

      <!-- <ng-container>
        <device-capture></device-capture>
      </ng-container> -->

      <ng-container>
        <device-imei></device-imei>
      </ng-container>

      <!-- <ng-container>
        <h1 class="margin-bottom-medium">Upload your IMEI number</h1>
      </ng-container> -->

      <!-- <ng-container>
        <h1 class="margin-bottom-medium">Thank you!</h1>
      </ng-container> -->
    </div>
  </div>
</div>